import {
  HealthDiaryPathsEnum,
  HealthDiaryRoutesEnum,
} from "@ch/router/HealthDiaryRoutes/enums.ts";
import StepsHistoryPageLazy from "@ch/pages/StepsPage/StepsHistoryPageLazy.tsx";
import StepsLogPageLazy from "@ch/pages/StepsPage/StepsLogPageLazy.tsx";
import StepsPageLazy from "@ch/pages/StepsPage";
import postHogFeatureFlagKeys from "@ch/helpers/utils/postHogAnalytics/postHogFeatureFlagKeys.ts";
import FeatureFlagRouteGate from "@ch/components/Gate/FeatureFlagRouteGate.tsx";

export const stepsRoutes = [
  {
    path: HealthDiaryPathsEnum.STEPS_HISTORY,
    element: (
      <FeatureFlagRouteGate
        featureFlagName={postHogFeatureFlagKeys.CORSANO_METRICS}
      >
        <StepsHistoryPageLazy />
      </FeatureFlagRouteGate>
    ),
    handle: {
      meta: () => ({
        title: "Steps History",
      }),
      crumb: () => ({
        title: "Steps History",
        route: HealthDiaryRoutesEnum.HEALTH_DIARY_STEPS_HISTORY,
      }),
    },
  },
  {
    path: HealthDiaryPathsEnum.STEPS_LOG,
    element: (
      <FeatureFlagRouteGate
        featureFlagName={postHogFeatureFlagKeys.CORSANO_METRICS}
      >
        <StepsLogPageLazy />
      </FeatureFlagRouteGate>
    ),
    handle: {
      meta: () => ({
        title: "Steps Log",
      }),
      crumb: () => ({
        title: "Log Steps",
        route: HealthDiaryRoutesEnum.HEALTH_DIARY_STEPS_LOG,
      }),
    },
  },
  {
    path: HealthDiaryPathsEnum.STEPS,
    element: (
      <FeatureFlagRouteGate
        featureFlagName={postHogFeatureFlagKeys.CORSANO_METRICS}
      >
        <StepsPageLazy />
      </FeatureFlagRouteGate>
    ),
    handle: {
      meta: () => ({
        title: "Steps",
      }),
      crumb: () => ({
        title: "Steps",
        route: HealthDiaryRoutesEnum.HEALTH_DIARY_STEPS,
      }),
    },
  },
];
